import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import CompositionInput, { type CompositionItem, type CompositionInputProps } from './CompositionInput';

export interface ControlledCompositionInputProps<TFieldValues extends FieldValues = FieldValues>
    extends Omit<CompositionInputProps, 'value' | 'onChange' | 'error'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError;
    /** false — не показывать ошибку (для визарда до нажатия «Далее»/submit) */
    showError?: boolean;
}

export default function ControlledCompositionInput<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    showError = true,
    ...props
}: ControlledCompositionInputProps<TFieldValues>) {
    const { field, fieldState } = useController({
        control,
        name,
    });

    const error = showError ? fieldState.error || errorProp : undefined;

    const handleChange = (value: CompositionItem[]) => {
        field.onChange(value);
    };

    return (
        <CompositionInput
            value={field.value || [{ value: '', count: 0 }]}
            onChange={handleChange}
            error={error ? error.message : undefined}
            {...props}
        />
    );
}
